import { z } from 'zod';
/**
 * L'**adresse d'une demande** telle que les écrans l'impriment — la tournée, le tableau des
 * demandes, le planning, les relances, les avis de passage, la file d'export. Écrite une fois : six
 * copies de la même forme divergeaient au premier champ ajouté.
 *
 * ⚠️ **Le code postal est celui de l'adresse** (`Address.postal_code`) quand la source en a donné
 * un, celui de la commune sinon. Une commune nouvelle n'a qu'un code au référentiel alors que ses
 * communes déléguées gardent le leur : Montjean-sur-Loire est en 49570, pas en 49110 comme
 * Mauges-sur-Loire.
 *
 * `city` reste la **commune du référentiel** — celle du marché, des filtres et des regroupements
 * (M8, M31) ; `delegatedName` est la commune déléguée, `null` sans elle. Une adresse postale
 * s'écrit « 1 rue d'Anjou · Montjean-sur-Loire · 49570 Mauges-sur-Loire ».
 */
export const inquiryAddressSchema = z.object({
    street: z.string().nullable(),
    postalCode: z.string().nullable(),
    city: z.string().nullable(),
    delegatedName: z.string().nullable(),
});
//# sourceMappingURL=address.js.map